module.exports = __webpack_public_path__ + "fonts/be8a9ccb1eaa17fddaab82c5f674c212.svg";